export const MODE_GRAB = 0;
export const MODE_MARKER = 1;
export const MODE_POLYGON = 2;
console.log(process.env.REACT_APP_URL_ICON)
const IMAGE_URL = process.env.REACT_APP_URL_ICON ? process.env.REACT_APP_URL_ICON : "https://landmark.jesus-app.jp/.well-known/icon/";

export const colors = [
    {
        label: '赤色',
        value: '#ff0000',
    },
    {
        label: '青色',
        value: '#0000FF',
    },
    {
        label: '緑色',
        value: '#008000',
    },
    {
        label: '黄色',
        value: '#FFFF00',
    },
    {
        label: 'オリーブ色',
        value: '#808000',
    },
    {
        label: '黒色',
        value: '#000000',
    },
];
export const opacities = [
    {
        label: '0',
        value: '0',
    },
    {
        label: '0.2',
        value: '0.2',
    },
    {
        label: '0.4',
        value: '0.4',
    },
    {
        label: '0.6',
        value: '0.6',
    },
    {
        label: '0.8',
        value: '0.8',
    },
    {
        label: '1',
        value: '1',
    }
];
export const borderWeights = [
    // {
    //     label: '0',
    //     value: '0',
    // },
    {
        label: '1',
        value: '1',
    },
    {
        label: '2',
        value: '2',
    },
    {
        label: '3',
        value: '3',
    },
    {
        label: '4',
        value: '4',
    },
    {
        label: '5',
        value: '5',
    },
    {
        label: '6',
        value: '6',
    },
    {
        label: '7',
        value: '7',
    },
    {
        label: '8',
        value: '8',
    },
    {
        label: '9',
        value: '9',
    },
    {
        label: '10',
        value: '10',
    },
    // {
    //     label: '15',
    //     value: '15',
    // },
    // {
    //     label: '20',
    //     value: '20',
    // },
    // {
    //     label: '25',
    //     value: '25',
    // },
    // {
    //     label: '30',
    //     value: '30',
    // },
    // {
    //     label: '35',
    //     value: '35',
    // },
    // {
    //     label: '40',
    //     value: '40',
    // },
];
export const markerIcons = [
    {
        id:"beachFlags",
        iconUrl :"https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
        iconLinkUrl: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
        size: {
            width : 100,
            height : 100
        }
    },
    {
        id:"routeIcon-1",
        iconUrl :require("assets/img/park_route_1.png"),
        iconLinkUrl: IMAGE_URL + "park_route_1.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"routeIcon-2",
        iconUrl :require("assets/img/park_route_2.png"),
        iconLinkUrl: IMAGE_URL + "park_route_2.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"routeIcon-3",
        iconUrl :require("assets/img/park_route_3.png"),
        iconLinkUrl: IMAGE_URL + "park_route_3.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"routeIconLarge-1",
        iconUrl :require("assets/img/park_zoom_1.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_1.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"routeIconLarge-2",
        iconUrl :require("assets/img/park_zoom_2.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_2.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"routeIconLarge-3",
        iconUrl :require("assets/img/park_zoom_3.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_3.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"png-2",
        iconUrl :require("assets/img/park_ng_2_v2.png"),
        iconLinkUrl: IMAGE_URL + "park_ng_2_v2.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"png-3",
        iconUrl :require("assets/img/park_ng_3.png"),
        iconLinkUrl: IMAGE_URL + "park_ng_3.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"png-4",
        iconUrl :require("assets/img/park_ng_4.png"),
        iconLinkUrl: IMAGE_URL + "park_ng_4.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"png-5",
        iconUrl :require("assets/img/park_ng_5_v2.png"),
        iconLinkUrl: IMAGE_URL + "park_ng_5_v2.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"png-6",
        iconUrl :require("assets/img/park_ng_6.png"),
        iconLinkUrl: IMAGE_URL + "park_ng_6.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"png-7",
        iconUrl :require("assets/img/park_ng_7.png"),
        iconLinkUrl: IMAGE_URL + "park_ng_7.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"png-8",
        iconUrl :require("assets/img/park_ng_8.png"),
        iconLinkUrl: IMAGE_URL + "park_ng_8.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"png-9",
        iconUrl: require("assets/img/park_ng_9_v2.png"),
        iconLinkUrl: IMAGE_URL + "park_ng_9_v2.png",
        size: {
            width : 32,
            height : 32
        }
    },
    {
        id:"png_zoom-2",
        iconUrl :require("assets/img/park_zoom_ng_2.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_ng_2.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"png_zoom-3",
        iconUrl :require("assets/img/park_zoom_ng_3.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_ng_3.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"png_zoom-4",
        iconUrl :require("assets/img/park_zoom_ng_4.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_ng_4.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"png_zoom-5",
        iconUrl :require("assets/img/park_zoom_ng_5_v2.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_ng_5_v2.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"png_zoom-6",
        iconUrl :require("assets/img/park_zoom_ng_6.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_ng_6.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"png_zoom-7",
        iconUrl :require("assets/img/park_zoom_ng_7.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_ng_7.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"png_zoom-8",
        iconUrl :require("assets/img/park_zoom_ng_8.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_ng_8.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"png_zoom-9",
        iconUrl :require("assets/img/park_zoom_ng_9_v2.png"),
        iconLinkUrl: IMAGE_URL + "park_zoom_ng_9_v2.png",
        size: {
            width : 64,
            height : 64
        }
    },
    {
        id:"site",
        iconUrl: require("assets/img/onsite_route_1.png"),
        iconLinkUrl: IMAGE_URL + "onsite_route_1.png",
        size: {
            width : 32,
            height : 32
        }
    }
];

export function getIcon (id) {
    let ret = markerIcons.filter(icon=>icon.id == id)
    if ( ret == undefined ) {
        return null;
    }
    return ret[0]
}

export const aryAlphabet = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O"];

export function encodeArrayPoints (points) {
    var polypoint = '';
    var encodeNumber = function(num){  // 文字列変換
      var encodeString = '';
      while( num >= 0x20 ){            // ２進数５桁毎の処理
        encodeString +=(String.fromCharCode((0x20 | (num & 0x1f))+63));
        num >>= 5;                  
      }
      encodeString += (String.fromCharCode(num + 63)); // コードシフト
      return encodeString;
    };
    var encodeSignedNumber = function(num){
      var sgn_num = num << 1;          // １桁左シフト
      if( num < 0 ){
        sgn_num = ~(sgn_num);          // 負符号処理
      }
      return(encodeNumber(sgn_num));
    };
    var plat = 0; var plon = 0;  // 初期値設定
    for(let i=0; i<points.length; i++ ){
      var lat = parseFloat(points[i][0]);
      var lon = parseFloat(points[i][1]);
      var late5 = Math.floor(lat * 1e5);  // 有効桁数丸め
      var lone5 = Math.floor(lon * 1e5);  // 有効桁数丸め
      let dlat = late5 - plat;                // 差分値算出
      let dlon = lone5 - plon;                // 差分値算出
      plat = late5;                       // 前位置保存
      plon = lone5;                       // 前位置保存
      polypoint +=encodeSignedNumber(dlat) + encodeSignedNumber(dlon);
    }
    console.log(polypoint)
    return polypoint.replace(/\\/g,"\\\\"); // エスケープ符号対策
}